import { nextAppPublicEnvDefinition } from "./env-contracts/next-app.env-schema";
import { parseEnvSchema } from "./env-contracts/parse-env-schema";

// Must explicitly reference each NEXT_PUBLIC_* var for Next.js to inline them on the client
const clientEnvSource = {
  // Next.js replaces this with the page's deployment ID; local builds use false.
  NEXT_DEPLOYMENT_ID: process.env.NEXT_DEPLOYMENT_ID || undefined,
  NODE_ENV: process.env.NODE_ENV,
  NEXT_PUBLIC_SENTRY_DSN: process.env.NEXT_PUBLIC_SENTRY_DSN,
  NEXT_PUBLIC_STYTCH_TOKEN: process.env.NEXT_PUBLIC_STYTCH_TOKEN,
  NEXT_PUBLIC_POSTHOG_MARKETING_CAPTURE_KEY:
    process.env.NEXT_PUBLIC_POSTHOG_MARKETING_CAPTURE_KEY,
  NEXT_PUBLIC_POSTHOG_CAPTURE_KEY: process.env.NEXT_PUBLIC_POSTHOG_CAPTURE_KEY,
  NEXT_PUBLIC_DEPLOYMENT_REGION: process.env.NEXT_PUBLIC_DEPLOYMENT_REGION,
  NEXT_PUBLIC_SITE_URL: process.env.NEXT_PUBLIC_SITE_URL,
  NEXT_PUBLIC_SITE_URL_ALIASES: process.env.NEXT_PUBLIC_SITE_URL_ALIASES,
  NEXT_PUBLIC_MARKETING_SITE_URL: process.env.NEXT_PUBLIC_MARKETING_SITE_URL,
  NEXT_PUBLIC_DOCS_SITE_URL: process.env.NEXT_PUBLIC_DOCS_SITE_URL,
  NEXT_PUBLIC_BLOG_SITE_URL: process.env.NEXT_PUBLIC_BLOG_SITE_URL,
  NEXT_PUBLIC_TRUST_SITE_URL: process.env.NEXT_PUBLIC_TRUST_SITE_URL,
  NEXT_PUBLIC_ADMIN_URL: process.env.NEXT_PUBLIC_ADMIN_URL,
  NEXT_PUBLIC_LOCAL_SUPABASE_PROXY:
    process.env.NEXT_PUBLIC_LOCAL_SUPABASE_PROXY,
  NEXT_PUBLIC_SUPABASE_URL: process.env.NEXT_PUBLIC_SUPABASE_URL,
  NEXT_PUBLIC_SUPABASE_ANON_KEY: process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY,
  NEXT_PUBLIC_SUPABASE_READONLY_URL:
    process.env.NEXT_PUBLIC_SUPABASE_READONLY_URL,
  NEXT_PUBLIC_MUX_TRACKING_KEY: process.env.NEXT_PUBLIC_MUX_TRACKING_KEY,
  NEXT_PUBLIC_DATADOG_RUM_APPLICATION_ID:
    process.env.NEXT_PUBLIC_DATADOG_RUM_APPLICATION_ID,
  NEXT_PUBLIC_AG_GRID_LICENSE_KEY: process.env.NEXT_PUBLIC_AG_GRID_LICENSE_KEY,
  NEXT_PUBLIC_VERCEL_ENV: process.env.NEXT_PUBLIC_VERCEL_ENV,
  NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA:
    process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA,
  NEXT_PUBLIC_OTEL_RESOURCE_ATTRIBUTES:
    process.env.NEXT_PUBLIC_OTEL_RESOURCE_ATTRIBUTES,
};

export const clientEnv = parseEnvSchema(nextAppPublicEnvDefinition, {
  source: clientEnvSource,
});
